import { createRouter, createWebHistory, createWebHashHistory } from "vue-router";
import authRouter from '@/modules/auth/router';
import homeRouter from '@/modules/home/router';
import featureAnswersRouter from '@/modules/features-answers/router';
import diagnosticsRouter from '@/modules/diagnostics/router';
import workPlansRouter from '@/modules/work-plans/router';
import catalogsRouter from '@/modules/catalogs/router';
import organizationsRouter from '@/modules/organizations/router';
import usersRouter from '@/modules/users/router';
import store from '@/store';

const routes = [
  {
    path: "/",
    ...authRouter
  },
  {
    path: "/home",
    ...homeRouter
  },
  {
    path: "/features-answers",
    ...featureAnswersRouter
  },
  {
    path: "/diagnostics",
    ...diagnosticsRouter
  },
  {
    path: "/work-plans",
    ...workPlansRouter
  },
  {
    path: "/catalogs",
    ...catalogsRouter
  },
  {
    path: "/organizations",
    ...organizationsRouter
  },
  {
    path: "/users",
    ...usersRouter
  }
];

const router = createRouter({
  history: createWebHashHistory("/"),
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters['auth/isAuthenticated'];
  const isAdmin = store.getters['auth/isAdmin'];

  // Allow login/register routes
  if (to.matched.some(record => record.path === '/')) {
    next();
    return;
  }

  // Require authentication for all other routes
  if (!isAuthenticated) {
    next({ name: 'login' });
    return;
  }

  // Check admin requirement
  if (to.meta.requiresAdmin && !isAdmin) {
    next({ name: 'home-index' });
    return;
  }

  next();
});

export default router;
